import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { getApiUrl } from './config/runtime-config';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'angular-landing';

  get envLabel(): string {
    return getApiUrl().includes('dev.') ? 'DEV' : 'PROD';
  }

  get isDev(): boolean {
    return getApiUrl().includes('dev.');
  }
}
